import { getCategoryHref } from '../../utils/common/category';
import { PROMPT_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'promptGeneratorType',
      analyticsName: 'prompt_type',
      textLabel: 'Generate prompt for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: PROMPT_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'All',
        value: getCategoryHref(PROMPT_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'promptGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'prompt_generator_topic',
      textLabel: 'Describe what you want to create with AI',
      placeholder: 'E.g., "outline for quarterly presentation" or "new e-commerce logo."',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: PROMPT_GENERATOR_CATEGORY,
      isOptional: false,
      required: true,
      tooltipProps: null,
    },
  },
  {
    type: 'input',
    properties: {
      name: 'promptGeneratorDetails',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'prompt_generator_details',
      textLabel: 'Include the following details',
      placeholder: 'E.g., styles, platforms, resolutions, etc.',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      isOptional: true,
      selectedCategory: PROMPT_GENERATOR_CATEGORY,
      required: false,
      tooltipProps: null,
    },
  },
  {
    type: 'dropdown',
    properties: {
      information: null,
      name: 'length',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'length',
      textLabel: 'Choose length',
      isOptional: true,
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: 19,
      required: false,
      dropdownValues: [
        {
          title: 'Short',
          value: 'short',
        },
        {
          title: 'Medium',
          value: 'medium',
        },
        {
          title: 'Long',
          value: 'long',
        },
      ],
    },
  },
];

export default data;
